/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".stars-wrap{color:#f9795c}.gray-wrap{margin-left:-4px}.gray-wrap span{color:#d3d3d3}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/stars/stars.component.scss.ngstyle.js.pre-build-optimizer.js